import * as React from "react";
import { useForm } from "../../../../../hooks/use_form_v2";
import { Form } from "../../../../Components/Form/Form/Form";
import { BudgetField } from "../../../../Transactions/Components/Form/Fields/BudgetField";
import { AutomationsValidationErrors } from "../../../../../validators/automations";

interface ISetBudgetProps {
    value?: any;
    onChange(payload: ISetBudgetState): void;
    errors?: AutomationsValidationErrors;
}

interface ISetBudgetState {
    budget: any;
}

export const SetBudget = ({value, onChange, errors}: ISetBudgetProps) => {
    const form = useForm<ISetBudgetState>(value || {
        budget: '',
    }, {
        name: 'category',
        prevFormErrors: errors,
    });
    const { register, getValues } = form;

    React.useEffect(() => {
        onChange(getValues());
    }, [getValues()]);

    return (
        <>
            <Form.Field type={BudgetField} {...register('budget')} />
        </>
    )
};
